export { ArticlePageView as default } from './ArticlePageView';
